define('models/creativeAsset',["jQuery", "T1", "T1Model"], function ($, T1, T1Model) {
  T1.Models.CreativeAsset = T1Model.extend({
    url: "creative_assets/",
    fixture: "-creative_asset"
  });
  return T1.Models.CreativeAsset;
});
